import { endOfMonth, startOfMonth, subMonths } from 'date-fns';
import produce from 'immer';
import {
  snowflakeDownloadReport,
  snowflakeGetFirstTimers,
  snowflakeGetLocations,
  snowflakeGetStats,
  snowflakeGetTerminatedMembers,
  snowflakeSetDateRange,
  snowflakeSetLocation,
} from './actions';

/* eslint-disable default-case */
/* eslint-disable no-param-reassign */

const initialState = {
  loading: false,
  downloading: false,
  error: null,
  stats: null,
  firstTimers: [],
  firstTimersFilters: null,
  loadingFirstTimers: false,
  errorFirstTimers: null,
  terminatedMembers: [],
  terminatedMembersFilters: null,
  loadingTerminatedMembers: false,
  errorTerminatedMembers: null,
  dateRange: {
    startDate: startOfMonth(
      subMonths(new Date(), new Date().getDate() === 1 ? 2 : 1)
    ),
    endDate: endOfMonth(
      subMonths(new Date(), new Date().getDate() === 1 ? 2 : 1)
    ),
  },
  locations: [],
  locationsLoading: false,
  locationsError: null,
  selectedLocationId: null,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case snowflakeSetDateRange.toString():
      draft.dateRange = payload;
      break;
    case snowflakeSetLocation.toString():
      draft.selectedLocationId = payload;
      break;
    case snowflakeGetStats.REQUEST:
      draft.loading = true;
      draft.error = null;
      draft.stats = null;
      break;
    case snowflakeGetStats.SUCCESS:
      draft.stats = payload;
      break;
    case snowflakeGetStats.FAILURE:
      draft.error = payload;
      draft.stats = null;
      break;
    case snowflakeGetStats.FULFILL:
      draft.loading = false;
      break;
    case snowflakeGetFirstTimers.REQUEST:
      draft.loadingFirstTimers = true;
      draft.errorFirstTimers = null;
      draft.firstTimers = [];
      draft.firstTimersFilters = null;
      break;
    case snowflakeGetFirstTimers.SUCCESS:
      draft.firstTimers = payload.items;
      draft.firstTimersFilters = payload.filters;
      break;
    case snowflakeGetFirstTimers.FAILURE:
      draft.errorFirstTimers = payload;
      draft.firstTimers = [];
      draft.firstTimersFilters = null;
      break;
    case snowflakeGetFirstTimers.FULFILL:
      draft.loadingFirstTimers = false;
      break;
    case snowflakeGetTerminatedMembers.REQUEST:
      draft.loadingTerminatedMembers = true;
      draft.errorTerminatedMembers = null;
      draft.terminatedMembers = [];
      draft.terminatedMembersFilters = null;
      break;
    case snowflakeGetTerminatedMembers.SUCCESS:
      draft.terminatedMembers = payload.items;
      draft.terminatedMembersFilters = payload.filters;
      break;
    case snowflakeGetTerminatedMembers.FAILURE:
      draft.errorTerminatedMembers = payload;
      draft.terminatedMembers = [];
      draft.terminatedMembersFilters = null;
      break;
    case snowflakeGetTerminatedMembers.FULFILL:
      draft.loadingTerminatedMembers = false;
      break;
    // Different screens fetch locations with different server filters (e.g.
    // network performance passes ignorePre), so drop the previous screen's
    // list as soon as a new fetch starts instead of showing it while loading.
    case snowflakeGetLocations.REQUEST:
      draft.locations = [];
      draft.locationsLoading = true;
      draft.locationsError = null;
      break;
    case snowflakeGetLocations.SUCCESS:
      draft.locations = payload;
      break;
    case snowflakeGetLocations.FAILURE:
      draft.locationsError = payload;
      break;
    case snowflakeGetLocations.FULFILL:
      draft.locationsLoading = false;
      break;
    case snowflakeDownloadReport.REQUEST:
      draft.downloading = true;
      break;
    case snowflakeDownloadReport.FULFILL:
      draft.downloading = false;
      break;
  }
}, initialState);

export default reducer;
